import Vue from 'vue'
import Router from 'vue-router'

import AgeGate from './views/age-gate'
import Home from './views/home'
import CasaRelvas from './views/casa-relvas'
import Wines from './views/wines'
import WineFeatures from './components/wine-features'
import Contacts from './views/contacts'
import Enotourism from './views/enotourism'
import Sustainability from './views/sustainability'
import Search from './views/search'
import PrivacyPolicy from './views/privacy-policy'
import News from './views/news'
import NewsHome from './components/news-home'
import NewsArticle from './components/news-article'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            name: 'home',
            path: '/',
            component: Home
        },
        {
            name: 'age-gate',
            path: '/_',
            component: AgeGate
        },
        // {
        //     name: 'casa-relvas',
        //     path: '/family',
        //     alias: ['/familia', '/origin', '/origem', '/vision', '/visao', '/terroir','/team', '/equipa'],
        //     component: CasaRelvas
        // },
        {
            name: 'family',
            path: '/family',
            alias: ['/familia'],
            component: CasaRelvas
        },
        {
            name: 'origin',
            path: '/origin',
            alias: ['/origem'],
            component: CasaRelvas
        },
        {
            name: 'vision',
            path: '/vision',
            alias: ['/visao'],
            component: CasaRelvas
        },
        {
            name: 'terroir',
            path: '/terroir',
            component: CasaRelvas
        },
        {
            name: 'team',
            path: '/team',
            alias: ['/equipa'],
            component: CasaRelvas
        },
        {
            name: 'wines',
            path: '/wines/:id',
            alias: ['/vinhos/:id'],
            component: Wines,
            children: [
                {
                    path: ':wineid',
                    name: 'wine-features',
                    component: WineFeatures
                }
            ]
        },
        {
            path: '/enotourism',
            alias: ['/enoturismo'],
            name: 'enotourism',
            component: Enotourism
        },
        {
            path: '/sustainability',
            alias: ['/sustentabilidade'],
            name: 'sustainability',
            component: Sustainability
        },
        {
            path: '/contacts',
            alias: ['/contactos'],
            name: 'contacts',
            component: Contacts
        },
        {
            path: '/news',
            alias: ['/noticias'],
            component: News,
            children: [
                {
                    path: '',
                    name: 'news-home',
                    component: NewsHome
                },
                {
                    path: ':id',
                    name: 'news-article',
                    component: NewsArticle
                }
            ]
        },
        {
            path: '/search',
            alias: ['/pesquisa'],
            name: 'search',
            component: Search
        },
        {
            path: '/privacy-policy',
            alias: ['/politica-de-privacidade'],
            name: 'privacy-policy',
            component: PrivacyPolicy
        },
        {
            path: '*',
            redirect: '/'
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (to.name === from.name) {
            return savedPosition
        }

        return { x: 0, y: 0 }
    }
})

router.beforeEach((to, from, next) => {
    return sessionStorage.getItem('drinkable') || to.name === 'age-gate' ? next() : next('/_')
})

export default router
